.reel {
  display: flex;
  gap: var(--sp-3);
  /* Sized so the wide panel (7 of 12 flex shares) lands close to 16:9 at the full
     container width, keeping letterboxing small once the video plays in place. Not
     aspect-ratio + min-height: Chrome carries a min-height through the ratio into a
     minimum width (20rem × 3.2 = 64rem) that overflows tablet-width screens. */
  height: clamp(20rem, 26vw, 23.5rem);
}
.item {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: #000;
  transition:
    flex-grow 450ms var(--ease),
    border-color var(--dur) var(--ease);
}
.item:not(.active):hover,
.item:not(.active):focus-within {
  /* The peek: a sliver widens a little before it is chosen. */
  flex-grow: 1.8;
  border-color: var(--border-strong);
}
.active {
  flex-grow: 7;
  border-color: var(--border-strong);
}
.poster {
  position: absolute;
  inset: 0;
  height: 100%;
  aspect-ratio: auto !important;
}
.poster img {
  filter: saturate(0.55) brightness(0.6);
  transition: filter 450ms var(--ease);
}
.item:not(.active):hover .poster img,
.item:not(.active):focus-within .poster img {
  filter: saturate(0.85) brightness(0.8);
}
.active .poster img {
  filter: none;
}
.hit {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: var(--sp-3);
  width: 100%;
  padding: var(--sp-4);
  border: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0) 55%);
  color: var(--text-on-dark);
  text-align: left;
}
.hit:focus-visible {
  outline-offset: -3px;
}
.play {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 50%;
  background: rgba(16, 20, 25, 0.5);
  transition:
    width var(--dur) var(--ease),
    height var(--dur) var(--ease),
    background-color var(--dur) var(--ease);
}
.play::after {
  content: "";
  margin-left: 0.15rem;
  border-style: solid;
  border-width: 0.4rem 0 0.4rem 0.65rem;
  border-color: transparent transparent transparent currentColor;
}
.active .play {
  width: 3.75rem;
  height: 3.75rem;
  border-color: transparent;
  background: var(--accent);
  color: var(--text-on-accent);
}
.active .play::after {
  margin-left: 0.25rem;
  border-width: 0.65rem 0 0.65rem 1.1rem;
}
.active .hit:hover .play {
  background: var(--accent-hover);
}
.title {
  display: -webkit-box;
  max-width: 34rem;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: var(--fs-sm);
  font-weight: 600;
  line-height: var(--lh-snug);
  opacity: 0;
  transition: opacity var(--dur) var(--ease);
}
.item:not(.active):hover .title,
.item:not(.active):focus-within .title {
  opacity: 1;
}
.active .title {
  font-size: var(--fs-xl);
  letter-spacing: -0.01em;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.6);
  opacity: 1;
}
.frame {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: #000;
}
@media (max-width: 63.99rem) {
  /* Stacked: the chosen video on top at 16:9, the rest as titled strips below. Below
     ~64rem a six-panel row squeezes the wide panel to nearly square. */
  .reel {
    flex-direction: column;
    height: auto;
  }
  .item {
    flex: none;
    height: 4.5rem;
  }
  .active {
    height: auto;
    aspect-ratio: 16 / 9;
  }
  .hit {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .title {
    opacity: 1;
  }
  .active .hit {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
  }
  .active .title {
    font-size: var(--fs-lg);
  }
}
